import { Icon } from '@ui/lib/park/ui/icon';
import { Text } from '@ui/lib/park/ui/text';
import { RemoteConfigKey } from '@ui/lib/posthog/hooks/types';
import { useRemoteConfig } from '@ui/lib/posthog/hooks/useRemoteConfig';
import { HStack, VStack } from 'styled-system/jsx';

import Gear from '../icons/Gear';
import { useShouldShowMaintenanceBanner } from './hooks/useShouldShowMaintenanceBanner';

export const AnnouncementBanner = () => {
  const announcementConfig = useRemoteConfig(RemoteConfigKey.Announcement);

  const { description, title } = announcementConfig || {};

  const shouldShowMaintenanceBanner = useShouldShowMaintenanceBanner();

  if (!shouldShowMaintenanceBanner) return null;

  return (
    <HStack
      backgroundSize="cover"
      backgroundImage="url(/images/announce-bg.jpg)"
      w="full"
      p="16px"
      h={{
        base: 'auto',
        desktop: 'layout.announcementHeight',
      }}
    >
      <Icon color="primary.orangeLight" boxSize="20px">
        <Gear />
      </Icon>
      <VStack gap={1} w="full" alignItems="flex-start">
        <Text textStyle="headings.default" color="primary.orangeLight">
          {title}
        </Text>
        <Text textStyle="text.small">{description}</Text>
      </VStack>
    </HStack>
  );
};
